import React, { useState } from 'react';
import { IconFont } from 'ui-component-library';
import { useHistory } from 'react-router-dom';

import DropdownNavButton, { DropdownRow } from '../dropdown-nav-button';
import { WelcomeRow } from './user-nav-menu.style';
import userManager from '../../../../../helpers/userManager';
import { formatUsername } from '../../../../../utils/common';
import theme from '../../../../../theme';
import User from '../../../../../shapes/user';

/**
 * User navigation menu
 * @param {object} props - Object containing the props for this component
 * @param {object} props.user - current user
 * @return {element}
 */
const UserNavMenu = ({ user }) => {
  const history = useHistory();
  const [menuOpen, setMenuOpen] = useState(false);

  /**
   * Signs out the current user
   * @return {void}
   */
  const signOut = () => {
    userManager.signoutRedirect();
  };

  /**
   * Navigates user to profile settings screen
   */
  const openProfileSettings = () => {
    history.push('/profilesettings');
    setMenuOpen(false);
  };

  return (
    <DropdownNavButton icon="user-circle" isOpen={menuOpen} openMenu={setMenuOpen}>
      <WelcomeRow>
        {`Hi, ${formatUsername(user.username)}!`}
      </WelcomeRow>
      <DropdownRow onClick={openProfileSettings}>
        <IconFont icon="Cog" color={theme.palette.darkGray[100]} size="16px" />
        Profile Settings
      </DropdownRow>
      <DropdownRow onClick={signOut}>
        <IconFont icon="exit" color={theme.palette.darkGray[100]} size="16px" />
        Logout
      </DropdownRow>
    </DropdownNavButton>
  );
};

UserNavMenu.propTypes = {
  user: User.isRequired,
};

export default UserNavMenu;
